import { Badge, Button } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

function GameSearchResultDisplayer(props) {
    const { t } = useTranslation('messages');

    if (!props.hasSearched) return null;

    if (props.games.length === 0) {
        return (
            <div className="text-center py-5 text-muted">
                <Search size={48} className="mb-3 opacity-25" />
                <p className="mb-0">{t('main.game_search.empty_state')}</p>
            </div>
        );
    }

    return (
        <div>
            {props.games.map((game, index) => renderGameCard(game, index, props, t))}
        </div>
    );
}

function renderGameCard(game, index, props, t) {
    const favouriteIndex = props.favouriteGames.map(g => g.externalId).indexOf(game.externalId);
    const isFavourite = favouriteIndex > -1;
    const favouriteGame = isFavourite ? props.favouriteGames[favouriteIndex] : null;

    return (
        <div key={index} className="card border-0 shadow-sm mb-3">
            <div className="card-body p-3 d-flex gap-3 align-items-start">
                {game.imageLink && (
                    <img
                        src={game.imageLink}
                        alt={game.name}
                        className="rounded flex-shrink-0"
                        style={{ width: 72, height: 72, objectFit: 'cover' }}
                    />
                )}
                <div className="flex-grow-1 min-w-0">
                    <a
                        href={game.link}
                        target="_blank"
                        rel="noreferrer"
                        className="fw-semibold text-dark text-decoration-none"
                    >
                        {game.name}
                    </a>
                    {game.description && (
                        <p className="text-clamp text-muted small mb-2 mt-1">
                            {game.description}
                        </p>
                    )}
                    {favouriteGame && favouriteGame.gameLabels && favouriteGame.gameLabels.length > 0 && (
                        <div className="d-flex flex-wrap gap-1 mb-2">
                            {favouriteGame.gameLabels.map((gameLabel) => (
                                <Badge key={gameLabel.gameLabelId} bg="secondary">
                                    {gameLabel.name}
                                </Badge>
                            ))}
                        </div>
                    )}
                    <div className="d-flex flex-wrap gap-2 mt-2">
                        {isFavourite && (
                            <Button
                                size="sm"
                                variant="outline-primary"
                                onClick={() => props.onShowGameEditor(favouriteGame)}>
                                {t('main.game_search.result_edit_button_text')}
                            </Button>
                        )}
                        {isFavourite ? (
                            <Button
                                size="sm"
                                variant="outline-danger"
                                onClick={() => props.onDeleteGameClicked(game)}>
                                {t('main.game_search.result_delete_button_text')}
                            </Button>
                        ) : (
                            <Button
                                size="sm"
                                variant="outline-success"
                                onClick={() => props.onAddGameClicked(game)}>
                                {t('main.game_search.result_add_button_text')}
                            </Button>
                        )}
                        <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() => props.onSearchProductClicked(game.name)}>
                            {t('main.game_search.result_search_button_text')}
                        </Button>
                        <Button
                            size="sm"
                            variant="outline-secondary"
                            onClick={() => props.onCreateGameSessionClicked(game)}>
                            {t('game_sessions.create_session_button')}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default GameSearchResultDisplayer;
